import { CompanyContext } from "contexts/CompanyContext";
import { useContext } from "react";
import { api as Api } from "api/http";
import { getSocialNetworkIntegration } from "utils/getSocialNetworkIntegration";

export const useYoutube = () => {
    const { companySocials } = useContext(CompanyContext);
    const userLanguage = navigator.language || 'en';

    const getYoutubePlaylists = async () => {
        const socialNetwork = getSocialNetworkIntegration("youtube", companySocials);
        if (!socialNetwork) return [];
        
        let playlists = [];

        if (!playlists?.length) {
            try {
                playlists = await Api.get(`/socialNetworks/${socialNetwork.id}/playlists`, {
                    channelId: socialNetwork.external_id,
                    part: "snippet,contentDetails",
                    maxResults: 50
                })
                .then(res => res.data)
                .then(items=> {
                    return items?.map(playlist => ({
                        id: playlist.id,
                        title: playlist.snippet.title,
                        thumbnail: playlist.snippet.thumbnails?.medium?.url || null,
                    }));
                });
                
            } catch(error) {
                console.error("Error fetching playlists", error);
            }
        }

        return playlists && playlists?.length ? playlists : [];
    }

    const createYoutubePlaylist = async (name) => {
        const socialNetwork = getSocialNetworkIntegration("youtube", companySocials);
        if (!socialNetwork) return null;

        try {
            const playlist = await Api.post(`/socialNetworks/${socialNetwork.id}/playlists`, 
                {part: "snippet,status"}, 
                {
                    snippet: { title: name },
                    status: { privacyStatus: "public" }
                }
            ).then(res => res.data);

            const mappedPlaylist = {
                id: playlist.id,
                title: playlist.snippet.title,
                thumbnail: playlist.snippet.thumbnails?.default?.url || null,
                privacy: playlist.status.privacyStatus
            };

            return mappedPlaylist;
        } catch {
            return null;
        }
    }

    const getYoutubeCategories = async () => {
        const socialNetwork = getSocialNetworkIntegration("youtube", companySocials);
        if (!socialNetwork) return [];
        
        let categories = [];

        try {
            categories = await Api.get(`/socialNetworks/${socialNetwork.id}/categories`, {
                part: "snippet",
                regionCode: socialNetwork?.preferences?.region_code || 'US', 
                hl: userLanguage
            })
            .then(res => res.data)
            .then(items => {
                return items?.map(category => ({
                    id: category.id,
                    title: category.snippet.title,
                    assignable: category.snippet.assignable
                }));
            });
        } catch(error) {
            console.error("Error fetching categories", error);
        }

        return categories && categories?.length ? categories : [];
    }

    return { 
        getYoutubePlaylists, 
        createYoutubePlaylist,
        getYoutubeCategories 
    }
} 